import { Token } from '@/domain/types/Token'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'
import { CommonDialogProps, DialogConfig } from '../common/types'
import { WithdrawDialogContentContainer } from './WithdrawDialogContentContainer'
import { useWrongNetwork } from '@/domain/hooks/useWrongNetwork'
import { useEffect } from 'react'
import { track } from '@/features/analytics'

export interface WithdrawDialogProps extends CommonDialogProps {
  token: Token
}

function WithdrawDialog({ token, open, setOpen }: WithdrawDialogProps) {
  const isWrongNetwork = useWrongNetwork()

  useEffect(() => {
    track('lend_borrow_asset_selected', {
      token: token.symbol,
      market: token.address,
      market_type: 'standard',
      action_type: 'withdraw',
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isWrongNetwork) {
    setOpen(false)
    return null
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined}>
        <WithdrawDialogContentContainer token={token} closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const withdrawDialogConfig: DialogConfig<WithdrawDialogProps> = {
  options: {
    closeOnChainChange: true,
  },
  element: WithdrawDialog,
}
